import { render, staticRenderFns } from "./businessRisk.vue?vue&type=template&id=000bf8e7&scoped=true"
import script from "./businessRisk.vue?vue&type=script&lang=js"
export * from "./businessRisk.vue?vue&type=script&lang=js"
import style0 from "./businessRisk.vue?vue&type=style&index=0&id=000bf8e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bf8e7",
  null
  
)

export default component.exports